/* CUSTOM_FREIGHTWEIGHTS_BY_CLAUDE (ONYX b5bdb0db213f, Ryan 2026-10-09)
   Settings -> Admin: Shopify Weights From Shipments - the JS half. Markup in snippets/rep-settings-weight-sync.liquid.

   GET/POST /admin/freight-weight-sync-config is the switch (loaded from the server, never defaulted in the markup;
   Save stays disabled until it loaded). GET /admin/freight-weight-sync shows what tonight's run would write and
   the last run. GET /freight-weight-gaps?vendor=ECORE lists every ECORE product with a variant Shopify cannot
   weigh, and what the freight estimate uses for it instead. Nothing here writes a weight. */
(function () {
  'use strict';

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) { if (el) el.className = 'rep-settings__message'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function lb(n) { return n == null ? 'none' : (Math.round(Number(n) * 1000) / 1000) + ' lb'; }
  var SOURCE_WORDS = {
    measured: 'measured', joint: 'mixed loads solved', split: 'shared shipments',
    site: 'website number', seed: 'supplier sheet', shopify: 'catalog', thickness: 'thickness rule'
  };
  function table(head, rows) {
    return '<table style="width:100%;border-collapse:collapse;"><thead><tr style="text-align:left;background:var(--rq-bg-subtle,#f6f7f9);">'
      + head.map(function (h) { return '<th style="padding:6px 8px;">' + esc(h) + '</th>'; }).join('')
      + '</tr></thead><tbody>' + rows.join('') + '</tbody></table>';
  }
  function td(v) { return '<td style="padding:5px 8px;border-top:1px solid var(--rq-border,#e5e7eb);vertical-align:top;">' + v + '</td>'; }

  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var enabled = document.getElementById('settings-weightsync-enabled');
    var drift = document.getElementById('settings-weightsync-drift');
    var btn = document.getElementById('settings-weightsync-btn');
    var planBtn = document.getElementById('settings-weightsync-plan');
    var gapsBtn = document.getElementById('settings-weightsync-gaps');
    var msg = document.getElementById('settings-weightsync-msg');
    var list = document.getElementById('settings-weightsync-list');
    if (!enabled || !btn) return;

    (async function load() {
      try {
        var cfg = await window.RepPortal.API.get('/admin/freight-weight-sync-config');
        enabled.checked = !!(cfg && cfg.enabled === true);
        drift.value = (cfg && cfg.driftPct) || 5;
        btn.disabled = false;
      } catch (e) {
        showMsg(msg, 'Could not load the current setting - reload before saving.', 'error');
      }
    })();

    btn.addEventListener('click', async function () {
      hideMsg(msg);
      btn.disabled = true;
      try {
        var res = await window.RepPortal.API.post('/admin/freight-weight-sync-config', { enabled: !!enabled.checked, driftPct: Number(drift.value) });
        if (res && res.error) throw new Error(res.error);
        enabled.checked = !!(res && res.enabled === true);
        drift.value = res && res.driftPct;
        showMsg(msg, res && res.enabled
          ? 'Saved - measured weights are copied into Shopify every night around 3:30 AM Mountain.'
          : 'Saved - nothing is written to Shopify.', 'success');
      } catch (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      } finally { btn.disabled = false; }
    });

    planBtn.addEventListener('click', async function () {
      hideMsg(msg);
      list.innerHTML = 'Reading...';
      try {
        var r = await window.RepPortal.API.get('/admin/freight-weight-sync');
        var plan = (r && r.plan) || [];
        var html = '';
        var last = r && r.lastRun;
        html += '<p style="margin:0 0 8px;">' + (last
          ? 'Last run ' + esc(String(last.at).slice(0, 16).replace('T', ' ')) + ' UTC: ' + esc(last.wrote) + ' weight(s) written.'
          : 'It has not run yet.') + '</p>';
        html += table(['Product', 'Measured weight', 'Would do', 'Why'], plan.map(function (p) {
          var rate = p.rate ? lb(p.rate.lbPerUnit) + ' (' + esc(SOURCE_WORDS[p.rate.source] || p.rate.source) + (p.rate.n ? ', ' + p.rate.n + ' shipment' + (p.rate.n === 1 ? '' : 's') : '') + ')' : '';
          var does = p.action === 'write'
            ? 'write ' + p.writes.length + ' variant' + (p.writes.length === 1 ? '' : 's') + ': ' + p.writes.slice(0, 3).map(function (w) { return lb(w.from) + ' to ' + lb(w.to); }).join(', ')
            : 'nothing';
          return '<tr>' + td(esc(p.title || p.handle)) + td(rate) + td(does) + td(esc(p.why || '')) + '</tr>';
        }));
        var recent = (r && r.recentWrites) || [];
        if (recent.length) {
          html += '<p style="margin:12px 0 6px;font-weight:600;">Recently written</p>';
          html += table(['When (UTC)', 'Product', 'SKU', 'Before', 'After'], recent.map(function (w) {
            return '<tr>' + td(esc(String(w.at).slice(0, 16).replace('T', ' '))) + td(esc(w.handle)) + td(esc(w.sku)) + td(lb(w.from)) + td(lb(w.to)) + '</tr>';
          }));
        }
        list.innerHTML = html || 'Nothing to show.';
      } catch (e) {
        list.innerHTML = '';
        showMsg(msg, 'Could not read the plan: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }
    });

    gapsBtn.addEventListener('click', async function () {
      hideMsg(msg);
      list.innerHTML = 'Reading Shopify...';
      try {
        var g = await window.RepPortal.API.get('/freight-weight-gaps?vendor=ECORE');
        var rows = (g && g.products) || [];
        var html = '<p style="margin:0 0 8px;">' + esc(g.productsWithGaps) + ' of ' + esc(g.productsChecked)
          + ' ECORE products have a variant with no weight in Shopify (' + esc(g.unweighedVariants) + ' variants). '
          + esc((g.noFallback || []).length) + ' cannot be estimated at all.</p>';
        html += table(['Product', 'Variants with no weight', 'Freight estimate uses', 'Confidence'], rows.map(function (p) {
          var f = p.fallback;
          return '<tr>' + td(esc(p.title)) + td(esc(p.unweighedVariants) + ' of ' + esc(p.variants))
            + td(f ? lb(f.lbPerUnit) + ' a unit (' + esc(SOURCE_WORDS[f.source] || f.source) + ')' : '<strong style="color:#b91c1c;">nothing - set it in Shopify</strong>')
            + td(f ? esc(f.confidence) : '') + '</tr>';
        }));
        list.innerHTML = html;
      } catch (e) {
        list.innerHTML = '';
        showMsg(msg, 'Could not read the gaps: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }
    });
  }

  /* CUSTOM_CRATEFIT_BY_CLAUDE (Ryan 2026-10-09) - GET /admin/crate-fit shows each exact-weight supplier's crate weights and
     proven fits; POST /admin/crate-fit-config saves the supplier names ("Key = name, name" per line). */
  function namesToText(groups) {
    return (groups || []).map(function (g) { return g.key + ' = ' + (g.names || []).filter(function (n) { return n !== g.key; }).join(', '); }).join(String.fromCharCode(10));
  }
  function textToNames(text) {
    return String(text || '').split(/[\r\n]+/).map(function (line) {
      var parts = line.split('=');
      var key = (parts[0] || '').trim();
      if (!key) return null;
      var names = (parts[1] || '').split(',').map(function (n) { return n.trim(); }).filter(Boolean);
      return { key: key, names: [key].concat(names) };
    }).filter(Boolean);
  }
  function initCrates() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var names = document.getElementById('settings-cratefit-names');
    var save = document.getElementById('settings-cratefit-save');
    var show = document.getElementById('settings-cratefit-show');
    var msg = document.getElementById('settings-weightsync-msg');
    var list = document.getElementById('settings-weightsync-list');
    if (!names || !save || !show) return;
    var last = null;
    async function load() {
      last = await window.RepPortal.API.get('/admin/crate-fit');
      names.value = namesToText(last && last.config && last.config.exactSuppliers);
      save.disabled = false;
      return last;
    }
    load().catch(function () { showMsg(msg, 'Could not load the crate settings - reload before saving.', 'error'); });
    save.addEventListener('click', async function () {
      hideMsg(msg);
      save.disabled = true;
      try {
        var res = await window.RepPortal.API.post('/admin/crate-fit-config', { exactSuppliers: textToNames(names.value) });
        if (res && res.error) throw new Error(res.error);
        names.value = namesToText(res.exactSuppliers);
        showMsg(msg, 'Saved the exact-weight suppliers.', 'success');
      } catch (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      } finally { save.disabled = false; }
    });
    /* CUSTOM_PALLETTARE_BY_CLAUDE - Accept / Reject on a held crate reading. */
    list.addEventListener('click', async function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('[data-crate-verdict]') : null;
      if (!b) return;
      b.disabled = true;
      try {
        var res = await window.RepPortal.API.post('/admin/crate-fit/tare-verdict', { supplier: b.getAttribute('data-supplier'), ref: b.getAttribute('data-ref'), source: b.getAttribute('data-source'), verdict: b.getAttribute('data-crate-verdict') });
        if (res && res.error) throw new Error(res.error);
        showMsg(msg, 'Saved. The crate weight now uses ' + (b.getAttribute('data-crate-verdict') === 'accepted' ? 'that reading.' : 'the readings without it.'), 'success');
        show.click();
      } catch (e) {
        b.disabled = false;
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }
    });
    show.addEventListener('click', async function () {
      hideMsg(msg);
      list.innerHTML = 'Reading...';
      try {
        var d = await load();
        var html = '';
        (d.suppliers || []).forEach(function (s) {
          var sum = s.summary || {};
          /* CUSTOM_PALLETTARE_BY_CLAUDE (Ryan 2026-10-10) - the crate weight is the TOP of the readings, an outlier is
             dropped once there are three, and two that disagree hold the newer one here for Accept / Reject. */
          html += '<p style="margin:10px 0 6px;font-weight:600;">' + esc(s.key) + ': ' + esc(sum.readings || 0) + ' reading(s)'
            + (sum.tare ? ', crate weight used: ' + esc(sum.tare.lb) + ' lb (readings ' + esc(sum.tare.min) + ' to ' + esc(sum.tare.max) + ' lb, ' + (sum.tare.from === 'measured' ? 'from real shipments' : 'from weight/dims answers') + ')' : '') + '</p>';
          (sum.sizes || []).forEach(function (sz) {
            var t = sz.tare || {};
            (t.held || []).forEach(function (h) {
              html += '<p style="margin:4px 0;color:#b45309;">Held for you: ' + esc(sz.size) + ' crate weighs ' + esc(h.lb) + ' lb on ' + esc(h.ref || 'a reading')
                + ', but it has been ' + esc(t.lb) + ' lb. Use it? '
                + '<button type="button" class="rep-settings__submit" style="padding:2px 10px;margin-left:4px;" data-crate-verdict="accepted" data-supplier="' + esc(s.key) + '" data-ref="' + esc(h.ref || '') + '" data-source="' + esc(h.source || '') + '">Accept</button> '
                + '<button type="button" class="rep-settings__submit" style="padding:2px 10px;margin-left:4px;" data-crate-verdict="rejected" data-supplier="' + esc(s.key) + '" data-ref="' + esc(h.ref || '') + '" data-source="' + esc(h.source || '') + '">Reject</button></p>';
            });
            (t.dropped || []).forEach(function (h) {
              html += '<p style="margin:4px 0;color:#6b7280;">Left out as a likely mistake: ' + esc(sz.size) + ' crate ' + esc(h.lb) + ' lb on ' + esc(h.ref || 'a reading') + ' (more than 25 lb from the middle reading).</p>';
            });
          });
          var rows = [];
          (sum.sizes || []).forEach(function (sz) {
            (sz.fits || []).forEach(function (f) {
              rows.push('<tr>' + td(esc(sz.size)) + td(sz.tare ? esc(sz.tare.lb) + ' lb' : '') + td(esc(f.units) + ' units / ' + esc(Number(f.goodsLb).toLocaleString('en-US')) + ' lb on ' + esc(f.crates || 1) + ' crate' + ((f.crates || 1) === 1 ? '' : 's'))
                + td(esc(f.ref || '')) + td(f.source === 'dims' ? 'weight/dims answer' : 'real shipment') + '</tr>');
            });
          });
          html += rows.length ? table(['Crate', 'Crate weight', 'Proven to hold', 'From', 'Source'], rows) : '<p style="margin:0;">No one-crate shipment on record yet.</p>';
          (s.skipped || []).slice(0, 8).forEach(function (k) {
            html += '<p style="margin:4px 0;color:#b45309;">Not used: ' + esc(k.ref) + ' (' + esc(k.why) + (k.notExact && k.notExact.length ? ': ' + esc(k.notExact.slice(0, 2).join('; ')) : '') + ')</p>';
          });
        });
        list.innerHTML = html || 'Nothing to show.';
      } catch (e) {
        list.innerHTML = '';
        showMsg(msg, 'Could not read the crates: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCrates);
  else initCrates();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_FREIGHTWEIGHTS_BY_CLAUDE */
